<template>
    <v-form v-model="valid" ref="form" @submit.prevent="submit()">
        <v-row>
            <v-col cols="6">
                <v-text-field
                    v-model="form.spend_ratio"
                    outlined
                    type="number"
                    :rules="[rules.required('every_spend')]"
                >
                    <template v-slot:prepend>
                        <div class="text-no-wrap">
                            {{ $t('every_spend') }}
                        </div>
                    </template>
                </v-text-field>
            </v-col>
            <v-col col="6">
                <v-text-field
                    v-model="form.point_ratio"
                    outlined
                    type="number"
                    :rules="[rules.required('points')]"
                >
                    <template v-slot:prepend>
                        <div class="text-no-wrap">
                            {{ $t('for') }}
                        </div>
                    </template>
                    <template v-slot:append-outer>
                        <div class="text-no-wrap">
                            {{ $t('points') }}
                        </div>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit" :loading="loading" class="px-4">{{ $t('update_setting') }}</v-btn>
        </v-card-actions>
    </v-form>    
</template>
<script>
import vForm from '@/mixins/vForm';

export default {
    mixins: [vForm],

    data() {
        return {
            form: {
                spend_ratio: null,
                point_ratio: null,
            }
        }
    },

    created() {
        this.getSetting();
    },

    methods: {
        async submit() {
            this.loading = true;

            if(!this.$refs.form.validate()) {
                return;
            }

            await axios.post(api.path('merchant.update_setting', {id: this.$route.params.id}), this.form).then(res => res.data).then(res => {
                this.$toastr.s(this.$t('setting_updated'));
            })
            .catch(err => {
                this.$toastr.e(err.response.data.message)
            });

            this.loading = false;
        },

        getSetting() {
            axios.get(api.path('merchant.setting', {id: this.$route.params.id}), this.form).then(res => res.data).then(res => {
                this.form.spend_ratio = res.data.spend_ratio;
                this.form.point_ratio = res.data.point_ratio;
            });
        }
    }
}
</script>